var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tableTop10Grid-body"},_vm._l((_vm.infos),function(info,idx){return _c('TableItem',{key:idx,attrs:{"info":info}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }